import { useEffect, useState } from "react";

const STORAGE_KEY = "geolop:activeDomainId";

function readStored(): number | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const n = raw ? Number(raw) : NaN;
    return Number.isFinite(n) ? n : null;
  } catch { return null; }
}

const CHANGE_EVENT = "geolop:active-domain-changed";

function writeStored(id: number | null) {
  try {
    if (id === null) localStorage.removeItem(STORAGE_KEY);
    else localStorage.setItem(STORAGE_KEY, String(id));
  } catch { /* localStorage yoksa (gizli mod vb.) sessizce yoksay */ }
  // Aynı sayfadaki DİĞER hook örnekleri de anında güncellensin (sidebar seçici → içerik)
  try { window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: id })); } catch { /* SSR yok */ }
}

/**
 * Sayfalar arası KALICI "aktif domain" — bir domainde çalışırken domain-agnostic bir
 * sayfaya geçince (Sayfa Güçlendirme, İçerik Önerileri, Trafik Analizi, İçerik Takvimi)
 * her seferinde listedeki İLK domaine (domains[0]) düşmesin diye.
 *
 * urlDomainId verilirse (ör. sidebar'ın /domains/:id regex'i) o OTORİTERdir: hem local
 * state'i hem localStorage'ı günceller ki başka bir sayfa da onu görsün. urlDomainId
 * yoksa (domain-agnostic sayfa), son kaydedilen domain'e düşülür; o da yoksa domains[0]'a.
 */
export function useActiveDomain(
  domains: { id: number }[] | undefined,
  urlDomainId?: number | null,
): [number | null, (id: number) => void] {
  const [selected, setSelected] = useState<number | null>(() => readStored());

  // Başka bir bileşen (sidebar seçici) domaini değiştirince bu örnek de güncellenir
  useEffect(() => {
    const onChange = (e: Event) => {
      const id = (e as CustomEvent<number | null>).detail;
      setSelected((cur) => (id !== cur ? id : cur));
    };
    window.addEventListener(CHANGE_EVENT, onChange);
    return () => window.removeEventListener(CHANGE_EVENT, onChange);
  }, []);

  useEffect(() => {
    if (urlDomainId != null && urlDomainId !== selected) {
      setSelected(urlDomainId);
      writeStored(urlDomainId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [urlDomainId]);

  // Kayıtlı domain artık listede yoksa (silinmiş) veya hiç seçim yoksa → ilk domaine düş.
  useEffect(() => {
    if (urlDomainId != null) return; // URL otoriter olduğunda fallback'e gerek yok
    if (!domains || domains.length === 0) return;
    if (selected !== null && domains.some((d) => d.id === selected)) return;
    const fallback = domains[0]?.id ?? null;
    setSelected(fallback);
    writeStored(fallback);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [domains, urlDomainId]);

  const select = (id: number) => { setSelected(id); writeStored(id); };
  return [selected, select];
}
